import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material'
import React from 'react'

const ReactionToLight = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Reaction To Light</InputLabel>
      <Select
        value={moduleValues?.[`Reaction To Light (${side})`] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [`Reaction To Light (${side})`]: e.target.value,
          }))
        }
        label="Reaction To Light"
      >
        <MenuItem value="Brisk">Brisk</MenuItem>
        <MenuItem value="Sluggish">Sluggish</MenuItem>
        <MenuItem value="Not Reactive">Not Reactive</MenuItem>
        <MenuItem value="Unable to Assess">Unable to Assess</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default ReactionToLight
